import { INoteEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { NoteStore } from "sh-note-store";

export default mutatorAction('UPDATE_NOTE_IN_STORE', function updateNoteInStore(note: INoteEntity) {
    NoteStore().notes.set(note.id, note);
});
